import { isWebView } from 'shared/constants/AppTypeConstants';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';

export function autoCloseWebView(delay: number = 3000) {
  if (isWebView) {
    setTimeout(() => {
      MobileAppBridge.closeScreen();
    }, delay);
  }
}
